<template lang="pug">
    v-row
        v-btn( v-if='typeof updateState == "string" ' :href='updateState' rounded color='primary') Descargar
        v-btn(icon :loading="typeof updateState == 'number' " @click="$refs.inputUpload.click()" )
            v-icon( ) fas fa-file-upload
        input( v-show="false" ref="inputUpload" type="file" @change='inputImage' accept='image/*,.pdf' )

</template>
<script>
import {storage} from '@/FirebaseConfig'
import { watch } from 'fs';
export default {
  data: ()=>({
    value: '',
    imageFile: '',
    updateState: null
  }),
  props: {
    title: String,
  },
  methods: {
    onClickButton (value) {
      this.$emit('getUrl', value)
    },
    inputImage(event){
      this.updateState = null 
      let image = this.imageFile=event.target.files[0]
      let _this=this
      let uploadTask = storage.ref(`/images/${image.name}`).put(image)
      uploadTask.on('state_changed', function(snapshot){
        _this.updateState = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      }, function(error) {
        console.log(error)
      }, function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          _this.updateState = downloadURL
          
        })
      })
    }
    
  },
  watch:{
    'updateState'(){
      this.$emit('getUrl', this.updateState);
    }
  }
}
</script>

